<section
    [id]="id()"
    [attr.data-testId]="currentTestId()"
    [attr.data-styletarget]="id()"
    [attr.data-uitype]="'card'"
    class="w-full flex sm:flex-col sm:items-center sm:gap-y-[25px]"
>
    <section class="sm:pl-[10px] tablet:pl-[25px]">
        <img
            ngSrc="https://www.dat.com/wp-content/uploads/media/images/trendlines/gas_pump.png" class="h-full" alt="Gas Pump"  priority  width="86" height="145"
        />
    </section>
    <section
        class="w-1/2 grid grid-cols-[auto_1fr] gap-2 grid-rows-[1fr_100px] px-[20px] sm:px-0"
    >
        <h4
            class="col-start-2 self-stretch col-span-1 uppercase text-center font-body-1-strong py-2 m-0 text-white"
        >
            Fuel Price/Gallon
        </h4>
       
        <p
            class="col-start-2 col-span-1 m-0 self-stretch bg-dat-flame-400 rounded-[10px] flex p-0 justify-center items-center"
        >
            <span class="font-headline-3-strong text-dat-grey-900">
                ${{ cost() }}</span
            >
        </p>
    </section>
    <section
        class="w-1/2 grid grid-cols-[auto_1fr] gap-2 grid-rows-[1fr_100px] px-[20px] sm:px-0"
    >
        <h4
            class="col-start-2 self-stretch col-span-1 uppercase text-center font-body-1-strong py-2 m-0 text-white"
        >
            Weekly Percent Change
        </h4>
        <p
            class="col-start-2 col-span-1 m-0 self-stretch bg-dat-flame-400 rounded-[10px] flex p-0 justify-center items-center"
        >
            <span class="font-headline-3-strong text-dat-grey-900">
                {{ percentChange() }}%</span
            >
        </p>
    </section>
    <div [attr.data-json-info]="'fuel-prices'" class="hidden">
        {{ data() | json }}
    </div>
    <meta name="description" [content]="data() | json" />
</section>
